import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-anamnese-success',
  templateUrl: './anamnese-success.component.html',
  styleUrls: ['./anamnese-success.component.scss']
})
export class AnamneseSuccessComponent {
  faCircleCheck = faCircleCheck;

  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/']);
  }
}
